<template>
    <div class="yq-es-query-editor">
        <div class="yq-es-query-editor-switch">
            <el-radio v-model="parsedValue.type" label="string" @change="onTypeChange">条件表达式</el-radio>
            <el-radio v-model="parsedValue.type" label="builder" @change="onTypeChange">条件编辑器</el-radio>
        </div>
        <es-query-input v-if="parsedValue.type==='string'" v-model="parsedValue.stringValue"></es-query-input>
        <es-query-group v-else-if="dataSource" :data-source="dataSource" v-model="parsedValue.builderValue"></es-query-group>
    </div>
</template>

<script>
    import EsQueryInput from "./EsQueryInput";
    import datasourceConfigService from '../../service/datasource-config'
    import {buildQueryFromQueryGroup} from '../../service/EsQueryUtils'

    export default {
        name: "EsQueryEditor",
        components: {EsQueryInput},
        props: {
            value: String,
            dataSourceId: Number
        },
        data() {
            return {
                parsedValue: this.parseValue(this.value),
                dataSource: null
            }
        },
        watch: {
            'value': {
                deep: true,
                handler: function (val) {
                    if (val === this.getValue()) {
                        return
                    }
                    this.parsedValue = this.parseValue(val)
                }
            },
            'parsedValue': {
                deep: true,
                handler: function () {
                    this.$emit('input', this.getValue())
                }
            },
            dataSourceId() {
                this.init()
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                const dataSource = (await datasourceConfigService.getDatasourceConfig(this.dataSourceId)).data
                dataSource.fields = JSON.parse(dataSource.fields)
                this.dataSource = dataSource
            },
            getValue() {
                return this.parsedValue.type === 'string' ? this.parsedValue.stringValue : JSON.stringify(this.parsedValue.builderValue)
            },
            parseValue(value) {
                let type
                let builderValue = {
                    type:'group',
                    logic:'and',
                    children:[]
                }
                let stringValue
                if (value) {
                    if (value.startsWith("{")) {
                        type = 'builder'
                        builderValue = JSON.parse(value)
                    } else {
                        type = 'string'
                        stringValue = value
                    }
                } else {
                    type = 'string'
                    stringValue = value
                }
                return {
                    type,
                    builderValue,
                    stringValue
                }
            },
            onTypeChange(){
                if(this.parsedValue.type==='string'){
                    this.parsedValue.stringValue=buildQueryFromQueryGroup(this.parsedValue.builderValue)
                }
            }
        }
    }
</script>

<style scoped>
.yq-es-query-editor{
    display: inline-block;
    width: 100%;
}
</style>
